<template>
  <div style="padding: 20px" >
    <el-page-header @back="router.back">
      <template #content>
        <el-tag effect="plain" style="font-size: 15px;letter-spacing: 2px" type="success">
          {{ project.cname }}的销售送货单详情
        </el-tag>
      </template>
      <template #extra>
        <CUOutboundOrder :mode="'update'" :id="projectId"  @updatedProject="findProject" />
      </template>
    </el-page-header>
    <el-row :gutter="30" style="margin-top: 10px">
      <el-col :span="24">
        <el-card>
          <el-descriptions :column="2" border>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">
                  送货单号
                </div>
              </template>
              <el-text>{{ project.order_id }}</el-text>
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">
                  送货日期
                </div>
              </template>
              {{ project.out_date }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">
                  客户名称
                </div>
              </template>
              <el-text>{{ project.cname }}</el-text>
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">
                  业务员
                </div>
              </template>
              <el-text>{{ project.salesman }}</el-text>
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">
                  生产计划
                </div>
              </template>
              {{ project.plan }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">
                  备注
                </div>
              </template>
              {{ project.remark }}
            </el-descriptions-item>
            <el-descriptions-item :span="2">
              <template #label>
                <div class="cell-item">
                  操作
                </div>
              </template>
              <el-space wrap>
                <CUProductItem :mode="'create'" :id="projectId" @createdProject="list"/>
                <el-button :icon="Printer" type="success"  round  @click="printReport" v-if="pageInfo.total > 0">预览及打印送货单</el-button>
                <el-button type="danger" plain round @click="odoDelete">删除销售送货单</el-button>
              </el-space>
            </el-descriptions-item>
          </el-descriptions>
          <el-table :show-summary="(pageInfo.pages == pageInfo.current) && pageInfo.total > 0" :summary-method="getSummaries" :data="testReportData" border stripe style="width: 100%;margin-top: 10px" v-loading="loadingData"  element-loading-text="销售出库单数据加载中, 请稍后">
            <el-table-column type="index" fixed width="50" :index="index => index + 1 + (pageInfo.current - 1) * 8"/>
            <el-table-column label="产品品号" prop="customer_name" show-overflow-tooltip width="400">
              <template #default="scope">
                {{ scope.row.pcode }}
              </template>
            </el-table-column>
            <el-table-column label="产品名称" prop="pname" width="180"/>
            <el-table-column label="产品规格型号" prop="pmodel" width="180" align="center"></el-table-column>
            <el-table-column label="数量" prop="amount" width="180"/>
            <el-table-column label="备注" prop="remark" width="180"/>
            <el-table-column label="更新时间" prop="update_time" width="180"/>
            <el-table-column align="center" fixed="right" header-align="center" label="操作">
              <template #default="scope">
                <CUProductItem :mode="'update'" :id="scope.row.id" @updatedProject="list"/>
                <el-button plain size="small" type='danger' style="margin-left: 3px" @click="itemDelete(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 10px;" >
            <el-pagination style="float: right;height: 50px; line-height: 50px;margin-right: 2px" layout="total, prev, pager, next, slot" :total="pageInfo.total" :pager-count="3" :page-size="pageInfo.pageSize" v-model:current-page="pageInfo.current" @current-change="list">
              <el-button circle @click="list" >
                <el-icon :class="loadingData ? 'is-loading' : ''"><Refresh /></el-icon>
              </el-button>
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {ElMessage} from "element-plus";
import {Refresh, Printer} from '@element-plus/icons-vue';
import {get} from "@/assets/js/utils";
import {useRoute, useRouter} from "vue-router";
import CUOutboundOrder from "@/components/CUOutboundOrder";
import CUProductItem from "@/components/CUProductItem";
const router = useRouter();
const route = useRoute();
const loadingData = ref(false);
const project = ref({});
function printReport(){
  router.push("/print/" + project.value.id)
}
const {id: projectId} = route.params;

function findProject(){
  get('/find?id=' + projectId, ({code, data}) => {
    if (code == 0){
      project.value = data.data;
    }
  })
}

findProject()

function getSummaries(param) {
  const { columns} = param
  const sums  = []
  columns.forEach((column, index) => {
    if (index == 4) sums[4] = project.value.total;
    else if (index == 3) sums[3] = '数量合计'
    else sums[0] = ''
  })
  return sums
}


const testReportData = ref([])
const pageInfo = reactive({
  total:0,
  current: 1,
  pageSize: 8,
  pages: 0,
})

function list(callback) {
  loadingData.value = true;
  get(`/item/list?pageSize=${pageInfo.pageSize}&pageNum=${pageInfo.current}&odo_id=` + projectId, ({code, data}) => {
    if (code == 0){
      let result = data.data;
      pageInfo.total = result.total;
      pageInfo.pages = result.pages;
      setTimeout(() => {
        testReportData.value = result.list
        if (callback && (typeof callback == 'function')) callback();
        findProject()
      }, 1100)
    }
  }, () => {
      testReportData.value = []
  }, () => {
    setTimeout(() => loadingData.value = false, 1100)
  })
}


function itemDelete(id) {
  loadingData.value = true;
  get(`/item/delete?id=${id}`, ({code, message}) => {
    ElMessage({
      message,
      type: code == 0 ? 'success' : 'info',
      duration: 10000
    })
    if (code == 0){
      setTimeout(() => {
        list()
      }, 100)
    }
  }, null, () => {
    setTimeout(() => loadingData.value = false, 100)
  })
}


function odoDelete() {
  get(`/delete?id=${projectId}`, ({code, message}) => {
    ElMessage({
      message,
      type: code == 0 ? 'success' : 'info',
      duration: 10000
    })
    if (code == 0){
      setTimeout(() => {
        router.back()
      }, 1000)
    }
  })
}


onMounted(()=>{
  list()
})


</script>

<style>
.table-border{
  border: 1px solid #333;
}
</style>